<template>
  <ForceNewsBlockWrapper :requireCharacters="requireCharacters"
                         :titleLabel="$t('profile.label.bo_loss_maximum_amount')"
                         :parentScreen="parentScreen">
    <div class="form-group row">
      <div class="col-md-6 offset-md-3">
        <div class="input-group">
          <template v-if="this.isParentScreenEditProfile && isCorporation">
            <input type="text"
                   maxlength="7"
                   class="form-control bo-loss-max-amount"
                   v-model="$v.input['amsCustomerDetail.boLossMaxAmount'].$model"
                   name="boLossMaxAmount"
                   v-convert-fullwidth-to-halfwidth
                   v-numbers-only
                   @input="validateSelfAssetAndBoMaxLoss">
            <div class="input-group-append ">
              <span class="input-group-text currency-addon bg-light-gray">
                {{ $t('profile.label.max_loss_amount.unit') }}
              </span>
            </div>
          </template>
          <template v-if="this.isParentScreenForceNew || (this.isParentScreenEditProfile && !isCorporation)">
            <input type="text"
                   class="form-control bo-loss-max-amount"
                   v-model="$v.input['amsCustomerDetail.boLossMaxAmount'].$model"
                   name="boLossMaxAmount"
                   @keyup="amountKeyUp()"
                   @keydown="amountKeyDown($event)"
                   v-convert-fullwidth-to-halfwidth
                   v-numbers-only
                   @input="validateSelfAssetAndBoMaxLoss">
            <div class="input-group-append ">
              <span class="input-group-text currency-addon bg-light-gray">
                {{ $t('profile.label.max_loss_amount.unit') }}
              </span>
            </div>
          </template>
        </div>
        <div
            v-if="$v.input['amsCustomerDetail.boLossMaxAmount'].$error || $v.input['amsCustomerDetail.boLossMaxAmount'].$anyError"
            class="error-messages ng-active">
          <div v-if="!$v.input['amsCustomerDetail.boLossMaxAmount'].required">
            <div>{{ $t('MSG_TRS_NAF_0004_param', {param1: $t('profile.label.bo_loss_maximum_amount')}) }}</div>
          </div>
          <div
              v-if="$v.input['amsCustomerDetail.boLossMaxAmount'].required && !$v.input['amsCustomerDetail.boLossMaxAmount'].validBoMaxLoss">
            <div>{{ input.messageBoMaxLossAmount }}</div>
          </div>
        </div>
        <p class="form-text text-muted">{{ $t('profile.message.below_bo_max_loss_amount') }}</p>
      </div>
    </div>
    <template v-if="this.isParentScreenEditProfile">
      <div class="form-action">
        <button class="btn btn-sm btn-submit btn-success mr-2"
                :disabled="isDisabledButtonSubmit"
                :type="this.getButtonType()">
          {{ $t('profile.button.submit') }}
        </button>
        <button class="btn btn-default btn-cancel btn-sm"
                type="button"
                @click.prevent="reverseInput">
          {{ $t('profile.button.cancel') }}
        </button>
      </div>
    </template>
  </ForceNewsBlockWrapper>
</template>
<script>
/**
 * @author HungNS
 */
import formMixin from '@/common/mixins/form';
import forceNewUtil from "@/common/mixins/forceNewUtil";
import {required} from 'vuelidate/lib/validators';
import {createNamespacedHelpers} from 'vuex';
import * as FORCE_NEWS_TYPE from '@/store/modules/force-news/type';
import * as EDIT_PROFILE_TYPE from '@/store/modules/edit-profile/type'
import _ from 'lodash';

const {mapActions: mapForNewsActions} = createNamespacedHelpers("forceNews");
const {mapActions: mapEditProfileActions} = createNamespacedHelpers("editProfile");
export default {
  name: "UpdateBoMaxLossAmount",
  props: {},
  data() {
    return {}
  },
  mixins: [formMixin, forceNewUtil],
  methods: {
    ...mapForNewsActions([FORCE_NEWS_TYPE.GET_VALIDATE_SELF_ASSET_AND_BO_MAX_LOSS]),
    ...mapEditProfileActions([EDIT_PROFILE_TYPE.GET_VALIDATE_BO_MAX_LOSS_AMOUNT]),

    validateSelfAssetAndBoMaxLoss: _.debounce(function () {
      if (this.isParentScreenForceNew) {
        //referent to SelfAsset
        this[FORCE_NEWS_TYPE.GET_VALIDATE_SELF_ASSET_AND_BO_MAX_LOSS]({messageId: this.input.messageId});
        this.handleForceNewEvent();
      }
      if (this.isParentScreenEditProfile) {
        this[EDIT_PROFILE_TYPE.GET_VALIDATE_BO_MAX_LOSS_AMOUNT](this.input);
      }
      this.$v.$touch();
    }, 50),

    amountKeyUp() {
      if (this.input && this.input['amsCustomerDetail.boLossMaxAmount']) {
        var val = this.input['amsCustomerDetail.boLossMaxAmount'];
        this.input['amsCustomerDetail.boLossMaxAmount'] = this.$options.filters.formatAmount(val, 7)
      }
    },

    amountKeyDown(e) {
      if (this.input) {
        var charCode = (e.which) ? e.which : e.keyCode;
        var val = this.input['amsCustomerDetail.boLossMaxAmount'];
        if (val && val.length >= 10 && !(charCode == 37 || charCode == 38 || charCode == 39 || charCode == 40 || charCode == 8 || charCode == 46 || charCode == 116)) {
          e.preventDefault();
          return false;
        }
      }
    },
  },
  validations() {
    return {
      input: {
        'amsCustomerDetail.boLossMaxAmount': {
          required,
          validBoMaxLoss: function () {
            return this.input.validBoMaxLoss
          }
        }
      }
    }
  },
  computed: {
    isCorporation() {
      return this.$store.state[this.namespace].isCorporation
    },
  },
}
</script>

<style scoped>
.bo-loss-max-amount {
    text-align:right; 
    background-color: #fff !important;
}
</style>
